module.exports = __webpack_public_path__ + "img/check.388bb963.svg";